module.exports = __webpack_public_path__ + "ce45addeb94dfd8cee39aa3127f260c2.fbx";